export function getdata(){
	var obj = {
		headData: [{
				title: "项目",
				prop:'title',
				
				width: "300px",
				custom: true,
			},
			{
				title: "行次",
				prop: "grade",
				custom: true,
				width: "100px"
			},
			{
				title: "本期金额",
				prop: "cwbbwzx_2_x_1",
				custom: true,
				width: "200px",
				
			},
			{
				title:'上期金额',
				prop:'cwbbwzx_2_x_2',
				
				width: "200px",
				custom: true,
			},
		],
		tableData: [{
				title: "一、经营活动产生的现金流量：",
				grade:'1',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},
			{
				title: "销售商品、提供劳务收到的现金",
				grade:'2',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "收到的税费返还",
				grade:'3',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "收到的其他与经营活动有关的资金",
				grade: "4",
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "经营活动现金流入小计",
				grade:'5',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "购买商品、接受劳务支付的现金",
				grade:'6',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "支付给职工以及为职工支付的现金",
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				grade:'7',
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "支付的各项税费",
				grade:'8',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "支付其他与经营活动有关的现金",
				grade:'9',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "经营活动现金流出小计",
				grade:'10',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "经营活动产生的现金流量净额",
				grade:'11',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "二、投资活动产生的现金流量：",
				grade:'12',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "收回投资收到的现金",
				grade:'13',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "取得投资收益收到的现金",
				grade:'14',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "处置固定资产、无形资产和其他长期资产收回的现金净额",
				grade:'15',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "处置子公司及其他营业单位收到的现金净额",
				grade:'16',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "收到其他与投资活动有关的现金",
				grade:'17',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资活动现金流入小计",
				grade:'18',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "购建固定资产、无形资产和其他长期资产所支付的现金",
				grade:'19',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资支付的现金",
				grade:'20',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "取得子公司及其他营业单位支付的现金净额",
				grade:'21',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "支付其他与投资活动有关的现金",
				grade:'22',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资活动现金流出小计",
				grade:'23',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资活动产生的现金流量净额",
				grade:'24',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "三、筹资活动所产生的现金流量：",
				grade:'25',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "吸收投资收到的现金",
				grade:'26',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "取得借款收到的现金",
				grade:'27',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "收到其他与筹资活动有关的现金",
				grade:'28',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "筹资活动现金流入小计",
				grade:'29',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_29_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_29_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "偿还债务支付的现金",
				grade:'30',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_30_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_30_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "分配股利、利润或偿付利息所支付的现金",
				grade:'31',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_31_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_31_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "支付其他与筹资活动有关的现金",
				grade:'32',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_32_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_32_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "筹资活动现金流出小计",
				grade:'33',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_33_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_33_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "筹资活动产生的现金流量净额",
				grade:'34',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_34_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_34_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "四、汇率变动对现金及现金等价物的影响",
				grade:'35',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_35_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_35_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "五、现金及现金等价物净增加额",
				grade:'36',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_36_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_36_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "加：期初现金及现金等价物余额",
				grade:'37',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "六、期末现金及现金等价物余额",
				grade:'38',
				disabledcwbbwzx_2_x_1:false,
				disabledcwbbwzx_2_x_2:false,
				cwbbwzx_2_x_1: {
					cellCode:"cwbbwzx_2_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbwzx_2_x_2: {
					cellCode:"cwbbwzx_2_37_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
			}
		]
	}
	return obj
}
